var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSocialchannelFacebook = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.571 26.534v-9.671h3.136l0.469-3.769h-3.605v-2.406c0-1.091 0.293-1.835 1.804-1.835l1.928-0.001v-3.371c-0.334-0.046-1.478-0.149-2.81-0.149-2.78 0-4.683 1.756-4.683 4.982v2.779h-3.144v3.769h3.144v9.671h3.76z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSocialchannelFacebook);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/socialchannel-facebook.42dd605cff8b0174dfafefc2ce2dcf22.svg";